import React from 'react';
import PropTypes from 'prop-types';
import DocTemplateRow from './doc_template_row';
import DocTemplateColumnHeader from './doc_template_column_header';

const columns = [
  { key: 'name', label: 'Name', sortKey: 'name' },
  { key: 'createdByName', label: 'Created By', sortKey: 'createdByName' },
  { key: 'updatedAt', label: 'Last Edited', sortKey: 'updatedAt' },
  { key: 'editedByName', label: 'Edited By', sortKey: 'editedByName' },
  { key: 'actions', label: '', sortKey: undefined }
];

export default function DocTemplateTable({
  templates,
  sortState,
  onSort,
  canDuplicate,
  onDuplicate,
  onDelete
}) {
  return (
    <div className="table-container overflow-y-hidden">
      <table className="table bo-search-results bordered table-hover">
        <thead>
          <tr>
            {columns.map(col => (
              <DocTemplateColumnHeader
                columnConfig={col}
                key={col.key}
                sortState={sortState}
                onSort={onSort}
              />
            ))}
          </tr>
        </thead>
        <tbody>
          {templates.map(template => (
            <DocTemplateRow
              canDuplicate={canDuplicate}
              key={template.id}
              template={template}
              onDelete={onDelete}
              onDuplicate={onDuplicate}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}

DocTemplateTable.propTypes = {
  canDuplicate: PropTypes.bool.isRequired,
  sortState: PropTypes.shape({
    name: PropTypes.string.isRequired,
    direction: PropTypes.oneOf(['asc', 'desc']).isRequired
  }).isRequired,
  templates: PropTypes.arrayOf(PropTypes.object).isRequired,
  onDelete: PropTypes.func.isRequired,
  onDuplicate: PropTypes.func.isRequired,
  onSort: PropTypes.func.isRequired
};
